import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import {
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_LOTNO,
  SORT_BIN,
  SORT_AUTOBIN,
  SORT_ITEM,
  SORT_CHECKED,
  SORT_USER,
  SORT_TYPE,
} from "../Containers/PalletCheck/PalletCheck";
import { formatDate } from "utility.js";

const STORE_PALLET_CHECK = "palletcheck";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class PalletCheckStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      //console.log(item);
      const name = this.configStore.items[item.ItemId];
      item.LotNo = parseInt(item.LotNo);
      item.QualityAlienseed =
        item.QualityAlienseed == -1.0 ? "Ny" : item.QualityAlienseed;
      item.ItemName =
        typeof name !== "undefined"
          ? name + (item.ItemRate ? " " + item.ItemRate : "")
          : "-";
      item.MachineText =
        this.configStore.machines[item.MachineId].Name +
        (item.CleaningCount ? " x" + item.CleaningCount : "");
      item.CleaningRateText =
        this.configStore.cleaningRates[item.CleaningRate].split("-")[0];
      item.Supplier = this.configStore.suppliers[item.SupplierId];
      item.Created = formatDate(item.Created);
      item.Terminated = item._Terminated ? formatDate(item._Terminated) : "";
      item.QualityFull = item.QualityFull ? JSON.parse(item.QualityFull) : null;
      item.CheckedName = item.Checked ? "Ellenőrizve" : "Ellenőrizendő";

      const type = this.typeOptions.find((type) => type.value === item.Type);
      item.TypeName = type ? type.label : item.Type;

      item.AutoBinCode = [
        item.AutoBin && item.AutoBin.Code,
        item.AutoBin2 && item.AutoBin2.Code,
      ]
        .filter((code) => code)
        .join(" | ");

      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.UserName +
        " " +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode
          ? item.BinCode + (item.Level != null ? "/" + item.Level : "") + " "
          : "") +
        (item.AutoBinCode ? item.AutoBinCode + " " : "") +
        item.Quantity +
        " " +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "") +
        item.CheckedName +
        " " +
        (item.AutoBin ? item.AutoBin.Code : "")
      ).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @action setItem(value) {
    let item;
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].Id === value.Id) {
        item = this.items[i];
        break;
      }
    }

    if (item) {
      const name = this.configStore.items[value.ItemId];
      item.LotNo = parseInt(value.LotNo);
      item.SealNum = value.SealNum;
      item.QualityAlienseed =
        value.QualityAlienseed == -1.0 ? "Ny" : value.QualityAlienseed;
      item.ItemName = typeof name !== "undefined" ? name : "-";
      item.MachineId = value.MachineId;
      item.CleaningCount = value.CleaningCount;
      item.CustomCleaningCount = value.CustomCleaningCount;
      item.MachineText =
        this.configStore.machines[value.MachineId].Name +
        (value.CleaningCount ? " x" + value.CleaningCount : "");
      item.CleaningRate = value.CleaningRate;
      item.CleaningRateText =
        this.configStore.cleaningRates[value.CleaningRate].split("-")[0];
      item.CustomCleaningRate = value.CustomCleaningRate;
      item.SupplierId = value.SupplierId;
      item.Supplier = this.configStore.suppliers[value.SupplierId];
      item.CustomSupplier = value.CustomSupplier;
      item.Created = formatDate(value.Created);
      item.Terminated = value.Terminated ? formatDate(value.Terminated) : "";
      item.BinCode = value.BinCode;
      item.Level = value.Level;
      item.BagType = value.BagType;
      item.BagCount = value.BagCount;
      item.Quantity = value.Quantity;
      item.Status = value.Status;

      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[value.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode ? item.BinCode + " " : "") +
        item.Quantity +
        " " +
        item.Created +
        " " +
        item.CheckedName +
        " " +
        (item.AutoBin ? item.AutoBin.Code : "")
      ).toLowerCase();
    }
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable hideChecked = true;
  @action changeHideChecked() {
    this.hideChecked = !this.hideChecked;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable searchtext = "";
  @action setSearchText(value) {
    this.searchtext = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable typeOptions = [
    { value: null, label: "Összes" },
    { value: "uzem", label: "Üzemben maradt / nincs tárhelye" },
    { value: "szallitas", label: "Szállítás alatt" },
    { value: "misplacedNear", label: "Hibás tárhelyen van (folyosón közel)" },
    { value: "misplacedFar", label: "Hibás tárhelyen van (folyosón távol)" },
    {
      value: "misplacedOther",
      label: "Hibás tárhelyen van (másik folyosón/raktárban)",
    },
    { value: "noRfid", label: "RFID olvasás nélkül megadott pozícióval" },
  ];
  @observable typeOption = this.typeOptions[0];
  @action setTypeOption(value) {
    this.typeOption = JSON.parse(JSON.stringify(value));
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField;
  @action setSortField(value) {
    this.sortField = value;
  }

  @observable sortDirection;
  @action setSortDirection(value) {
    this.sortDirection = value;
  }
  @action flipSortDirection() {
    this.sortDirection = this.sortDirection === SORT_ASC ? SORT_DESC : SORT_ASC;
  }

  @computed get filteredItems() {
    console.log("filter", this.search, this.typeOption);
    if (!this.search && this.typeOption.value === null && !this.hideChecked) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        if (this.hideChecked && item.Checked) return false;

        if (
          this.typeOption.value !== null &&
          item.Type !== this.typeOption.value
        ) {
          return false;
        }

        if (this.search) {
          const searches = this.search.split(" ");
          for (let i = 0; i < searches.length; i++) {
            const s = searches[i].toLowerCase();
            //console.log(s, item.FilterField)
            if (item.FilterField.indexOf(s) === -1) {
              return false;
            }
          }
        }

        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (!this.sortDirection || !this.sortField) {
      return this.filteredItems;
    }
    const sortedItems =
      [
        SORT_MACHINE,
        SORT_CLEANINGRATE,
        SORT_BIN,
        SORT_AUTOBIN,
        SORT_ITEM,
        SORT_CREATED,
        SORT_CHECKED,
        SORT_USER,
        SORT_TYPE,
      ].indexOf(this.sortField) > -1
        ? this.filteredItems.slice().sort((a, b) => {
            // empty values first, and two empty values are equal
            const v1 = a[this.sortField] || "";
            const v2 = b[this.sortField] || "";
            if (!v1 || !v2) return v1 ? 1 : v2 ? -1 : 0;
            return v1.localeCompare(v2, "hu");
          })
        : this.filteredItems.slice().sort((a, b) => {
            const v1 = parseInt(a[this.sortField]);
            const v2 = parseInt(b[this.sortField]);
            if (v1 === v2) return 0;
            return v1 > v2 ? 1 : -1;
          });

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable palletHistory;
  @action setPalletHistory(value) {
    this.palletHistory = value;
  }

  @observable sealnums = [];
  @action setSealnums(value) {
    this.sealnums = value;
  }

  @observable selectedPalletId = null;
  @action setSelectedPalletId(value) {
    this.selectedPalletId = value;
  }
  @computed get selectedPallet() {
    const pallets = JSON.parse(JSON.stringify(this.items));
    const pallet = pallets.find((p) => p.Id == this.selectedPalletId);
    return pallet;
  }
}

export { PalletCheckStore, STORE_PALLET_CHECK, SORT_ASC, SORT_DESC };
